import React from 'react';
import { StyledSource } from '../JurisdictionView/CallPane/CallPane.styles';

const CallSource = ({ source }) => (
  <StyledSource data-name="location-source">Source: {source}</StyledSource>
);

export default CallSource;
